import React, { useState, useEffect } from 'react';
import { NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, useTheme } from '@chakra-ui/react';
import { readableColor } from 'polished';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CountSelector = _ref => {
  let {
    isInCart,
    productStock,
    countInCart,
    currentCount,
    onChangeCount,
    disabled,
    cartMode
  } = _ref;
  const {
    0: countAvailable,
    1: setCountAvailable
  } = useState(productStock);
  const theme = useTheme();
  const changeCountAvailable = newCount => {
    if (Math.sign(newCount) !== -1) {
      setCountAvailable(newCount);
    }
  };
  useEffect(() => {
    if (isInCart && !cartMode) {
      changeCountAvailable(parseInt(productStock) - countInCart);
    } else {
      changeCountAvailable(parseInt(productStock));
    }
  }, [isInCart, cartMode, countInCart, productStock]);
  return ___EmotionJSX("div", null, ___EmotionJSX(NumberInput, {
    size: "md",
    mr: 5,
    mt: 5,
    width: "auto",
    maxWidth: 20,
    display: "inline-block",
    "aria-label": "Anzahl",
    defaultValue: 1,
    value: currentCount,
    min: 1,
    max: countAvailable,
    sx: {
      input: {
        color: `${readableColor(theme.base_color)} !important`
      }
    },
    onBlur: e => onChangeCount(e.target.value, isInCart.cartId),
    isDisabled: !countAvailable || disabled
  }, ___EmotionJSX(NumberInputField, null), ___EmotionJSX(NumberInputStepper, null, ___EmotionJSX(NumberIncrementStepper, null), ___EmotionJSX(NumberDecrementStepper, null))));
};
CountSelector.defaultProps = {
  cartMode: false
};
export default CountSelector;